module.exports = __webpack_public_path__ + "static/media/logo.b4412c2a.png";